import { Injectable } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { calendarI8n } from 'src/app/interface/calendar-i18n';
import CALENDAR_I18N from 'src/app/utilities/calendar-i18n';

@Injectable({
  providedIn: 'root'
})
export class CalenderTranslationService {
  locale: calendarI8n;
  constructor(private translate: TranslateService) {
    this.setLabels(this.translate.currentLang);
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.setLabels(event.lang);
    });
  }

  setLabels(locale: string) {
    this.locale = CALENDAR_I18N[locale];
  }
}
